<p class="a-text-h2 title">{{ 'common.re-login.title' | translate }}</p>

<adspt-login-form (loginSuccess)="$event ? success() : error()" />

<adspt-toaster
    *ngIf="toast.show"
    duration="3000"
    [type]="toast.type"
    [title]="toast.title"
    (closed)="toast.show = false"
/>
